import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for createPasswordResetRequest mutation
 */
export interface CreateResetPasswordRequestVariables {
  email: string;
  baseUrl: string;
}

/**
 * Create password reset request payload structure
 */
export interface CreatePasswordResetRequestPayload {
  resetRequest: string;
}

/**
 * Response structure for createPasswordResetRequest mutation
 */
export interface CreateResetPasswordRequestResponse {
  createPasswordResetRequest: CreatePasswordResetRequestPayload;
}

const createResetPasswordRequest: DocumentNode = gql`
  mutation CreatePasswordResetRequest($email: String!, $baseUrl: String!) {
    createPasswordResetRequest(email: $email, baseUrl: $baseUrl) {
      resetRequest
    }
  }
`;

export default createResetPasswordRequest;
